import { apiConfig, http } from "@api/base";
import { getSearchTotal } from "@api/utils";
import { faqsSerializer as serializer } from "./serializer";

const faqsURL = "/faqs/";

const get = async (faqId) => {
  const response = await http.get(`${faqsURL}${faqId}`);
  response.data = serializer.fromJSON(response.data);
  return response;
};

const create = async (data) => {
  const resp = await http.post(`${faqsURL}`, data);
  resp.data = serializer.fromJSON(resp.data);
  return resp;
};

const update = async (faqId, data) => {
  const response = await http.put(`${faqsURL}${faqId}`, data);
  response.data = serializer.fromJSON(response.data);
  return response;
};

const del = async (faqId) => {
  return await http.delete(`${faqsURL}${faqId}`);
};

const list = async (query = "") => {
  const queryString = query ? `?q=${query}` : "";
  const response = await http.get(`${faqsURL}${queryString}`);

  if (response.data.status === "success" && response.data.data) {
    const faqs = Array.isArray(response.data.data) ? response.data.data : [];
    response.data.hits = faqs.map((item) => serializer.fromJSON(item));
    response.data.total = response.data.total || faqs.length;
  } else if (response.data.hits) {
    response.data.total = getSearchTotal(response.data.hits);
    response.data.hits = response.data.hits.hits.map((hit) =>
      serializer.fromJSON(hit)
    );
  } else if (response.data.data) {
    response.data.hits = response.data.data.map((item) =>
      serializer.fromJSON(item)
    );
    response.data.total = response.data.total || response.data.data.length;
  } else {
    response.data.hits = [];
    response.data.total = 0;
  }

  return response;
};

const count = async (query) => {
  const response = await http.get(`${faqsURL}?q=${query}`);
  response.data = getSearchTotal(response.data.hits);
  return response;
};

export const faqsApi = {
  searchBaseURL: `${apiConfig.baseURL}${faqsURL}`,
  get,
  create,
  update,
  delete: del,
  list,
  count,
  serializer,
};
